
export const handdleAscending = (data:any) => {
    let sortedList = [...data].sort((a, b) => a.price - b.price);
    return sortedList
  };

export const handdleDescending = (data:any) => {
    let sortedList = [...data].sort((a, b) => b.price - a.price);
    return sortedList
  };